// Formatadores de campos em tempo real (aplicam máscara enquanto o usuário digita)

/**
 * Formata CPF ou CNPJ enquanto o usuário digita.
 * Detecta automaticamente se é CPF (≤11 dígitos) ou CNPJ (>11 dígitos).
 */
export const formatCPFCNPJ = (value) => {
  const numbers = value.replace(/\D/g, '');

  if (numbers.length <= 11) {
    // CPF: 000.000.000-00
    if (numbers.length <= 3) return numbers;
    if (numbers.length <= 6) return `${numbers.slice(0, 3)}.${numbers.slice(3)}`;
    if (numbers.length <= 9) return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6)}`;
    return `${numbers.slice(0, 3)}.${numbers.slice(3, 6)}.${numbers.slice(6, 9)}-${numbers.slice(9, 11)}`;
  } else {
    // CNPJ: 00.000.000/0000-00
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 5) return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
    if (numbers.length <= 8) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
    if (numbers.length <= 12) return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
    return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12, 14)}`;
  }
};

export const formatCEP = (value) => {
  const cep = value.replace(/\D/g, '');

  if (cep.length <= 5) return cep;

  return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
};

/**
 * Detecta automaticamente se é fixo (10 dígitos) ou celular (11 dígitos).
 */
export const formatPhone = (value) => {
  const phone = value.replace(/\D/g, '');

  if (phone.length <= 2) return phone;

  if (phone.length <= 6) return phone.replace(/(\d{2})(\d+)/, '($1) $2');

  if (phone.length <= 10) return phone.replace(/(\d{2})(\d{4})(\d+)/, '($1) $2-$3');

  return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
};

/**
 * Formata valor em reais enquanto o usuário digita, tratando os dígitos como
 * centavos (ex: "1000000" -> "R$ 10.000,00").
 */
export const formatCurrency = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return '';

  const centavos = digits.padStart(3, '0');
  const inteiro = centavos.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `R$ ${inteiro},${centavos.slice(-2)}`;
};

export const unformat = (value) => value.replace(/\D/g, '');
